"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;

var React = __importStar(require("react"));

var Container_1 = require("../Container/Container");

var LanguageDropdown_1 = require("../LanguageDropdown/LanguageDropdown");

require("./Footer.css");

var Footer =
/** @class */
function (_super) {
  __extends(Footer, _super);

  function Footer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Footer.prototype.render = function () {
    var _a = this.props,
        locale = _a.locale,
        locales = _a.locales,
        onChange = _a.onChange,
        i18n = _a.i18n,
        isFullscreen = _a.isFullscreen,
        className = _a.className,
        isFullWidth = _a.isFullWidth;
    var classes = 'dcl footer';

    if (isFullscreen) {
      classes += ' fullscreen';
    }

    if (className) {
      classes += ' ' + className;
    }

    if (isFullWidth) {
      classes += ' full-width';
    }

    return React.createElement(Container_1.Container, {
      className: classes
    }, React.createElement("div", {
      className: "main-footer"
    }, React.createElement(LanguageDropdown_1.LanguageDropdown, {
      locale: locale,
      locales: locales,
      onChange: onChange,
      upward: true,
      direction: "right",
      i18n: i18n.dropdown
    }), React.createElement("div", {
      className: "links"
    }, React.createElement("a", {
      href: "https://decentraland.org"
    }, i18n.links.home), React.createElement("a", {
      href: "https://decentraland.org/privacy"
    }, i18n.links.privacy), React.createElement("a", {
      href: "https://decentraland.org/terms"
    }, i18n.links.terms), React.createElement("a", {
      href: "https://decentraland.org/content"
    }, i18n.links.content), React.createElement("a", {
      href: "https://decentraland.org/ethics"
    }, i18n.links.ethics))), React.createElement("div", {
      className: "secondary-footer"
    }, React.createElement("div", {
      className: "social-links"
    }, React.createElement("a", {
      href: "https://dcl.gg/discord"
    }, React.createElement("i", {
      className: "social-icon discord"
    })), React.createElement("a", {
      href: "https://reddit.com/r/decentraland"
    }, React.createElement("i", {
      className: "social-icon reddit"
    })), React.createElement("a", {
      href: "https://github.com/decentraland"
    }, React.createElement("i", {
      className: "social-icon github"
    })), React.createElement("a", {
      href: "https://twitter.com/decentraland"
    }, React.createElement("i", {
      className: "social-icon twitter"
    }))), React.createElement("div", {
      className: "copyright"
    }, "\xA9 ", new Date().getFullYear(), " Decentraland")));
  };

  Footer.defaultProps = {
    i18n: {
      dropdown: {
        en: 'English',
        es: 'Spanish',
        fr: 'French',
        ja: 'Japanese',
        zh: 'Chinese',
        ko: 'Korean'
      },
      links: {
        home: 'Home',
        privacy: 'Privacy Policy',
        terms: 'Terms of Use',
        content: 'Content Policy',
        ethics: 'Code of Ethics'
      }
    }
  };
  return Footer;
}(React.PureComponent);

exports.Footer = Footer;